/**
 * Constantes d'authentification et rôles
 *
 * Rôle : Liste des emails superadmin, email démo, clé sessionStorage démo ; fonctions isSuperAdminEmail(), isDemoUserEmail().
 * Utilisé par NextAuth callbacks, Header, dashboard, pages protégées.
 * Technologies : TypeScript (const, function)
 */
/** Emails qui ont toujours le statut superadmin (en plus du flag is_superadmin en base). */
export const SUPERADMIN_EMAILS = ["arsene@otulaa.com", "otulaa@otulaa.com"] as const;

/** Email du compte utilisé pour les sessions de démonstration (présentation Otulaa). */
export const DEMO_USER_EMAIL = "contact@rpmdiffusion.com";

/** Clé sessionStorage : message de bienvenue démo déjà vu (une fois par connexion, effacée à la déconnexion). */
export const DEMO_WELCOME_SESSION_KEY = "otulaa_demo_welcome_seen";

export function isSuperAdminEmail(email: string | null | undefined): boolean {
  return Boolean(email && SUPERADMIN_EMAILS.includes(email as (typeof SUPERADMIN_EMAILS)[number]));
}

export function isDemoUserEmail(email: string | null | undefined): boolean {
  return Boolean(email && email.toLowerCase() === DEMO_USER_EMAIL.toLowerCase());
}
